import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../App';
import { useT } from '../i18n';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from './ui/table';

/*
  Clicks of the last 7 days that did not go as planned (plan: stage 3):
  blocked by protection, opened on the wrong domain, sent to the default URL,
  refused for non-payment. Hidden when there is nothing to report.
*/

function reasonText(t, reason) {
  switch (reason) {
    case 'blocked':
      return t('Blocked by protection (filters, bot and IP lists).');
    case 'wrong_domain':
      return t('Opened on another domain than the campaign is bound to: the visitor got an error.');
    case 'default_url':
      return t('Went to the default URL of the campaign: no stream matched, a stream had no address, or the campaign has no streams.');
    case 'unpaid':
      return t('The account had no active subscription: the link did not open.');
    default:
      return reason || '—';
  }
}

export default function ClickIssues({ campaignId }) {
  const { t } = useT();
  const [items, setItems] = useState([]);

  const load = useCallback(async () => {
    if (!campaignId) return;
    try {
      const res = await axios.get(`${API}/campaigns/${campaignId}/click-issues`);
      setItems(Array.isArray(res.data?.items) ? res.data.items : []);
    } catch (_e) {
      setItems([]);
    }
  }, [campaignId]);

  useEffect(() => {
    load();
  }, [load]);

  if (!items.length) return null;
  return (
    <Card data-testid="click-issues">
      <CardHeader>
        <CardTitle>{t('Clicks that did not go as planned (7 days)')}</CardTitle>
        <CardDescription>{t('Counted up to a minute late.')}</CardDescription>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>{t('Reason')}</TableHead>
              <TableHead className="text-right">{t('Clicks')}</TableHead>
              <TableHead>{t('Last')}</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {items.map((row) => (
              <TableRow key={row.reason}>
                <TableCell className="text-sm">{reasonText(t, row.reason)}</TableCell>
                <TableCell className="text-right tabular-nums">{row.count}</TableCell>
                <TableCell className="whitespace-nowrap text-xs">
                  {row.last_at ? new Date(row.last_at).toLocaleString() : '—'}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
